module.exports = __webpack_public_path__ + "胡学波-aba83b5f.png";